import React from 'react';
import {COLORS} from '@fupa/fupa-uikit';
import {PlayArrow, YouTube} from '@mui/icons-material';
import styled from 'styled-components';

const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${props => props.background ?? COLORS.white};
  border-radius: 50%;
  width: 100%;
  height: 100%;
`;

const DEFAULT_ICON_SIZE = 18;

export const getTeaserIcon = key => {
  switch (key) {
    case 'SPORT.VIDEO':
      return (
        <IconContainer>
          <img width={DEFAULT_ICON_SIZE} height={DEFAULT_ICON_SIZE} src='/sportvideo.svg' alt='Sport.Video' />
        </IconContainer>
      );
    case 'YouTube':
      return (
        <IconContainer>
          <YouTube style={{color: '#FF0000', fontSize: 24}} />
        </IconContainer>
      );
    case 'Staige':
      return (
        <IconContainer>
          <img width={DEFAULT_ICON_SIZE} height={DEFAULT_ICON_SIZE} src='/staige.svg' alt='Staige' />
        </IconContainer>
      );
    case 'Sporttotal':
      return (
        <IconContainer>
          <img width={DEFAULT_ICON_SIZE} height={DEFAULT_ICON_SIZE} src='/sporttotal.png' alt='Sporttotal' />
        </IconContainer>
      );
    default:
      return (
        <IconContainer background={COLORS.lightBlue}>
          <PlayArrow style={{color: COLORS.white, fontSize: DEFAULT_ICON_SIZE}} />
        </IconContainer>
      );
  }
};
